export default __webpack_public_path__ + "static/media/annonce.fcc5282e.ogg";